import { useState } from 'react';

import { cx } from '@libs/classnames';
import { CameraIcon } from '@ui/icons/CameraIcon';

import { MemberAux, parseMemberAux, patchCamerasRequired } from '@features/club/typings';

import { CamerasRequirementModal } from './CamerasRequirementModal';

import styles from './CamerasRequirementControl.module.css';

type Props = {
  userName: string;
  // aux участника клуба как есть: чужие поля сохраняем
  aux: unknown;
  onChange: (aux: MemberAux | null) => void;
};

// Сколько камер участник должен включать на видеоконтроле: иконка в списке (две — залитый
// корпус с цифрой), клик открывает выбор. Как с ФШР ID, но модалка своя в каждой строке
export function CamerasRequirementControl({ userName, aux, onChange }: Props) {
  const [isOpen, setOpen] = useState(false);
  const count = parseMemberAux(aux).camerasRequired ?? 1;

  return (
    <>
      <button
        type="button"
        className={cx(styles.control, { [styles.is_extra]: count > 1 })}
        title={`Камер на видеоконтроле: ${count}`}
        onClick={() => setOpen(true)}
      >
        <CameraIcon count={count} />
      </button>

      {isOpen && (
        <CamerasRequirementModal
          userName={userName}
          count={count}
          onSave={(next) => {
            onChange(patchCamerasRequired(aux, next));
            setOpen(false);
          }}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}
